import { render, staticRenderFns } from "./CreatorBannerSlider.vue?vue&type=template&id=89a8ac6c&"
import script from "./CreatorBannerSlider.vue?vue&type=script&lang=js&"
export * from "./CreatorBannerSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports